import {
  ExtensionDefinition,
  NavContentBlueprint,
  NavItemBlueprint,
  coreExtensionData,
  createExtension,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';

import { SidebarMenu } from './SidebarMenu';

export const Sidebar = createExtension({
  name: 'nav',
  attachTo: { id: 'app/layout', input: 'nav' },
  inputs: {
    items: createExtensionInput([NavItemBlueprint.dataRefs.target]),
    content: createExtensionInput([NavContentBlueprint.dataRefs.component], {
      singleton: true,
      optional: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  *factory({}) {
    yield coreExtensionData.reactElement(<SidebarMenu />);
  },
}) as ExtensionDefinition<any>;
